import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import { NavLink } from "react-router-dom";

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#0F172A",
        color: "rgba(255,255,255,0.6)",
        py: 4,
        mt: 0,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Typography
            variant="body2"
            sx={{ color: "rgba(255,255,255,0.85)", fontWeight: 600 }}
          >
            Matsuki Takeshi
          </Typography>
          <Box sx={{ display: "flex", gap: 3 }}>
            <NavLink to="/" style={{ textDecoration: "none" }}>
              <Typography
                variant="body2"
                sx={{
                  color: "rgba(255,255,255,0.5)",
                  "&:hover": { color: "rgba(255,255,255,0.9)" },
                  transition: "color 0.15s ease",
                  fontSize: "0.8rem",
                }}
              >
                Home
              </Typography>
            </NavLink>
            <NavLink to="/biography" style={{ textDecoration: "none" }}>
              <Typography
                variant="body2"
                sx={{
                  color: "rgba(255,255,255,0.5)",
                  "&:hover": { color: "rgba(255,255,255,0.9)" },
                  transition: "color 0.15s ease",
                  fontSize: "0.8rem",
                }}
              >
                Biography
              </Typography>
            </NavLink>
          </Box>
          <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
            © {new Date().getFullYear()} Matsuki Takeshi
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
export default Footer;
